import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { isExternalUrl } from '../../utils/utils';

const DynamicLink = ({ url, children, ...props }) => {
  const isExternal = isExternalUrl(url);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToTarget = hash => {
    const targetId = hash.substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn('Target element not found:', targetId);
    }
  };

  const handleClick = e => {
    if (url?.startsWith('#')) {
      e.preventDefault();

      if (location.pathname !== '/') {
        navigate('/', { state: { scrollTo: url } });
      } else {
        scrollToTarget(url);
      }
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo && location.pathname === '/') {
      const targetHash = location.state.scrollTo;
      setTimeout(() => {
        scrollToTarget(targetHash);
      }, 100);
    }
  }, [location]);

  if (isExternal) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }

  if (url?.startsWith('#')) {
    return (
      <a href={url} onClick={handleClick} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link to={url} {...props}>
      {children}
    </Link>
  );
};

export default DynamicLink;
